import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./OrderConfirm.scss";

import useResponsive from "../../../hooks/useResponsive";
import { LogoSection } from "../../../Components/LogoSection";
import { OrderSummary } from "../../../Components/OrderSummary";
import { Header, Subtitle, Title, Text } from "../../../Components/Typography";
import { Button } from "../../../Components/Button";
import { routes } from "../../../Router";
import {
  OrderContext,
  OrderContextProps,
} from "../../../Contexts/OrderContext";
import {
  FileUploadContext,
  FileUploadContextProps,
} from "../../../Contexts/FileUploadContext";
import {
  AddressContext,
  AddressContextProps,
} from "../../../Contexts/AddressContext";
import {
  PaymentContext,
  PaymentContextProps,
} from "../../../Contexts/PaymentContext";
import useLocalStorage from "../../../hooks/useLocalStorage";
import {
  AdminContext,
  AdminContextProps,
} from "../../../Contexts/AdminContext";

export const OrderConfirm = () => {
  const navigate = useNavigate();
  const { isDesktopOrLaptop } = useResponsive();
  const { storageKeys, getSessionStorageItem } = useLocalStorage();

  const { orderContextClear }: OrderContextProps =
    useContext<any>(OrderContext);

  const { fileUploadContextClear }: FileUploadContextProps =
    useContext<any>(FileUploadContext);

  const { addressContextClear }: AddressContextProps =
    useContext<any>(AddressContext);

  const { paymentContextClear }: PaymentContextProps =
    useContext<any>(PaymentContext);

  const { adminContextClear }: AdminContextProps =
    useContext<any>(AdminContext);

  const { selectedOrder }: AdminContextProps = useContext<any>(AdminContext);

  const trackingCode =
    getSessionStorageItem(storageKeys.randomId) ?? selectedOrder?.tracking_code;
  const trackingRoute = routes.clientOrderStatus.path.replace(
    ":trackingCode",
    `${trackingCode}`
  );
  const trackingUrl = `${window.location.origin}${trackingRoute}`;

  const clearAllForms = () => {
    orderContextClear();
    fileUploadContextClear();
    addressContextClear();
    paymentContextClear();
    adminContextClear();
  };

  const onClickNewOrder = () => {
    clearAllForms();
    navigate(routes.clientNewOrder.path);
  };

  const onClickReturn = () => {
    clearAllForms();
    navigate(routes.clientLogin.path);
  };

  useEffect(() => {
    return () => {
      clearAllForms();
    };
  }, []);

  return (
    <div
      className={
        isDesktopOrLaptop ? "order-confirm-desktop" : "order-confirm-mobile"
      }
    >
      <LogoSection style={{ marginRight: "10px" }} />

      {isDesktopOrLaptop && (
        <OrderSummary
          isPreview
          showAddressForm
          showPaymentForm
          style={{ marginLeft: "180px" }}
        />
      )}

      <div className="main-column">
        <div className="text-section">
          <div className="block">
            <Header>Finalización del pedido</Header>
            <Subtitle>¡Su pedido ha sido creado con éxito!</Subtitle>
          </div>

          <div className="block">
            <Text>
              Recibirá un email con la confirmación y detalles del pedido.{" "}
            </Text>
            <Text>
              En caso de no recibirlo, también puede hacer el seguimiento con el
              siguiente código:
            </Text>
          </div>

          <div className="block">
            <Title secondary>{trackingCode}</Title>
            <a target="_blank" href={trackingUrl}>
              <Text>{trackingUrl}</Text>
            </a>
          </div>
          <div className="block">
            <Text bold>
              A la hora de retirar su pedido, deberá presentar este código o el
              email que utilizó para realizarlo.
            </Text>
          </div>
          {isDesktopOrLaptop && (
            <div className="button-content">
              <Button onClick={onClickNewOrder}>crear nueva orden</Button>
              <Button outlined grey onClick={onClickReturn}>
                Volver al início
              </Button>
            </div>
          )}
        </div>

        {!isDesktopOrLaptop && (
          <div className="button-content">
            <Button onClick={onClickNewOrder} fullwidth>
              nueva orden
            </Button>
            <Button outlined grey onClick={onClickReturn} fullwidth>
              Volver al início
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
